import { SerializedStyles } from '@emotion/react';

import { dorosiwaCss } from '../css/dorosiwa';
import { xexymixCss } from '../css/xexymix';

export const VIDEO_RATIO = '16/9';

export const DESCRIPTION_CLASS_NAME = 'html_description';

export const instagramApi = 'https://www.instagram.com/embed.js';

export const whiteScriptList: string[] = [instagramApi, 'https://www.youtube.com/iframe_api'];

export const shopXexymix = '1898';
export const shopDorosiwa = '1357';

export const whiteStyleShopCssInfo: { [key: string]: SerializedStyles } = {
  [shopXexymix]: xexymixCss,
};

export const extraStyleShopCssInfo: { [key: string]: SerializedStyles } = {
  [shopDorosiwa]: dorosiwaCss,
};
